import { ButtonChangeLayout, Profile, View } from "@/components";

import type { JSX } from "react";
import type NavProps from "./types";

const TopNav = ({
  layout,
  sidebarIsOpen,
  setSidebarIsOpen
}: NavProps): JSX.Element => (
  <View
    type="nav"
    className={`px-4 xxl:px-6 shadow-sm duration-300 dark:border-b dark:border-n700 navbar-top z-20 ${
      sidebarIsOpen && layout === "Two Column"
        ? "w-full xxxl:w-[calc(100%-360px)] xxl:w-[calc(100%-280px)] ltr:xxxl:ml-[360px] ltr:xxl:ml-[280px] rtl:xxxl:mr-[360px] rtl:xxl:mr-[280px]"
        : "w-full"
    } ${
      sidebarIsOpen && layout === "Vertical"
        ? "w-full xxl:w-[calc(100%-280px)] xxxl:w-[calc(100%-336px)] ltr:xxl:ml-[280px] ltr:xxxl:ml-[336px] rtl:xxl:mr-[280px] rtl:xxxl:mr-[336px]"
        : "w-full"
    }  ${
      sidebarIsOpen && layout === "Hovered"
        ? "w-full xxl:w-[calc(100%-80px)] ltr:xxl:ml-[80px] rtl:xxl:mr-[80px] "
        : "w-full"
    }  py-4 xxl:py-6 gap-3 bg-n0 dark:bg-bg4 fixed flex justify-between items-center`}
  >
    <View className="flex grow md:gap-4 xxl:gap-6 items-center">
      <ButtonChangeLayout
        sidebarIsOpen={sidebarIsOpen}
        onClick={() => setSidebarIsOpen(!sidebarIsOpen)}
      />
    </View>
    <View className="flex items-center gap-3 sm:gap-4 xxl:gap-6">
      {/* <ModeSwitcher /> */}
      {/* <Notification /> */}
      {/* <SwitchLanguage /> */}
      <Profile />
    </View>
  </View>
);

export default TopNav;
